import { Hint } from '../../components/ui/hint';
import { useEffect, useState } from 'react';
import { api, errorLine } from '../../api/client';
import type { DeliveryReport } from '../../api/types';

export function DeliveryEvidenceTable({ view }: { view: DeliveryReport }) {
  if (!view.rows.length) return <p>No Quick Search or research operations recorded.</p>;
  return (
    <div className="credit-history">
      <table className="table">
        <thead>
          <tr>
            <th>Workload</th>
            <th>Completion evidence</th>
            <th>Missing evidence</th>
            <th>Current outcomes</th>
          </tr>
        </thead>
        <tbody>
          {view.rows.map((r) => (
            <tr key={r.kind}>
              <td>
                {r.kind === 'quick_search' ? 'Quick Search' : 'Research'}
                <div>{r.operations} operations</div>
              </td>
              <td>
                {r.supported} supported<div>{r.partial} partial</div>
              </td>
              <td>
                {r.unverified} unverified
                <div>{r.complete_without_receipt} complete without receipt</div>
              </td>
              <td>
                {r.in_progress} in progress · {r.failed} failed
                <details className="row-detail">
                  <summary>Changes after admission</summary>
                  {r.source_removed} source runs removed · {r.receipts_on_failed_runs} receipts on
                  subsequently failed runs
                </details>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function DeliveryReadiness({ orgId }: { orgId: string }) {
  const [view, setView] = useState<DeliveryReport | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    let live = true;
    setView(null);
    setError(null);
    api
      .deliveryReport(orgId)
      .then((v) => {
        if (live) setView(v);
      })
      .catch((e) => {
        if (live) setError(errorLine(e));
      });
    return () => {
      live = false;
    };
  }, [orgId, reload]);
  return (
    <section className="credit-card">
      <h3>Delivery evidence</h3>
      <Hint label="About delivery evidence">
        Supported: expected evidence recorded. Partial: some evidence missing. Unverified: no
        qualifying evidence. Historical receipts persist after removal, so outcome counts can
        overlap. Live charging settles from these receipts.
      </Hint>
      {error && <p role="alert">{error}</p>}
      {!view && !error && <p>Loading delivery reporting…</p>}
      {view && <DeliveryEvidenceTable view={view} />}

      <div className="form-actions">
        <button className="btn" type="button" onClick={() => setReload((n) => n + 1)}>
          Refresh delivery evidence
        </button>
      </div>
    </section>
  );
}
